<template>
  <div class="right">

    <rightTop @data="getCreditDataFn"></rightTop>

    <div class="rightCenter">
      <div class="centerTit">公司资讯</div>
      <div style="width:80%;position: relative;">
        <!-- <div @click="downloadFn(0)" style="float:right;height: 18px;font-size:14px;cursor: pointer;overflow: hidden;margin-top:21px;margin-left:20px;">
          <img src="@/assets/img/Excel.png" alt style="display: inline-block;height: 18px;width:18px;float:left;" />
          <span style="display: inline-block;height: 18px;line-height: 18px;width:auto;vertical-align: middle;color:#3583ED;margin-left:4px;float:left;">下载数据到Excel</span>
        </div> -->
        <!-- <div style="width:165px;float:right;position: relative;margin-left:10px;">
          <el-select @change="SelectTimeFn1" v-model="searchData1.value" size="small" placeholder="报表范围选择">
            <el-option
              v-for="item in searchData1.select"
              :key="item.announcementTypeId"
              :label="item.typeName"
              :value="item.announcementTypeId">
            </el-option>
          </el-select>
        </div>
        <el-input @change="changeInputFn" type="text" v-model="inputVal" size="small" placeholder="请输入公告标题的关键词" suffix-icon="el-icon-search" style="float:right;width:200px;"></el-input> -->
      </div>
    </div>
    <div class="rightBottom">
      <div class="tabulation">
        <el-table
            border
            size="mini"
            :data="tableData"
            :header-cell-style="cellStyle">
            <el-table-column
                width="200"
                prop="releaseTime"
                label="日期">
            </el-table-column>
            <el-table-column
                prop="title"
                label="资讯标题">
                <template slot-scope="scope">
                    <span @click="handlePageToFn(scope.row)" style="color:#3583ED;cursor:pointer;">{{scope.row.title}}</span>
                </template>
            </el-table-column>
        </el-table>
      </div>
      <div style="width:100%;margin-top:40px;">
        <el-pagination
          prev-text="上一页"
          next-text="下一页"
          background
          @current-change="handleCurrentChange"
          :page-size="limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/../static/common/api/api.js";
import magic from "@/../static/common/magic.js";
import rightTop from "@/components/rightTop";
export default {
  data() {
    return {
      //选择数据
      searchData1:{
        select:[],//下拉框选项数据
        value: '',
        type:''
      },
      inputVal:'',//输入数据
      tableData:[],
      companyList:[],
      paramsData:{},//URL参数集合
      offset:0,//page
      limit:10,
      total:0
    };
  },
  components:{
    rightTop
  },
  methods: {
    //收藏组件方法部分
    getCreditDataFn(data){
      console.log(data,'mytest')
      this.paramsData.stockCode = data[0].companyStockCode;
      this.paramsData.enterpriseCode = data[0].enterpriseCode;
      // this.paramsData.stockCode = "300034";
      // this.paramsData.enterpriseCode = '96cd49d4-7e23-11ea-b3e3-005056b8154d';
    //   this.fetchTimes();
      setTimeout(()=>{this.fetchTable()},500)//获取表格数据
    },
    cellStyle(row,column,rowIndex,columnIndex){
      return 'color: #333333;font-weight:bold;font-family:Microsoft YaHei;background:#F7F7F7;'
    },
    //表格点击跳转函数
    handlePageToFn(val){    
        window.location.href = val.url;
    },
    // 分页函数
    handleCurrentChange(val) {//当前页
      this.offset = (val-1)*this.limit;
      this.fetchTable();
    },
    //下载函数
    downloadFn(incomeType){
      let _this = this;
      this.download(window.baseUrl + '/capitalOperation/downHoldingSharesData?stockCode=' + this.paramsData.stockCode + '&enterpriseCode=' + this.paramsData.enterpriseCode);
    },
    download(url) {
      let a = document.createElement('a');
      a.href = url;
      let _id = Math.random()+Math.random();
      a.id = _id;
      a.click();
      window.URL.revokeObjectURL(url);
    },
    //第一个下拉框
    SelectTimeFn1(val){
        console.log(val,'val1');
        this.searchData1.type = val;
        this.offset = 0;
        this.fetchTable();//按产品
    },
    //input输入框触发函数
    changeInputFn(val){
        console.log(val,'val2');
        this.offset = 0;
        this.fetchTable();
    },
    //获取所有时间的选项
    fetchTimes(){
        let _this = this;
        api.announcementTimeOne().then(res=>{
            console.log(res,'time')
            let data = res.data;
            _this.searchData1.select = data;
            _this.searchData1.value = data[0].typeName;
            _this.searchData1.type = data[0].announcementTypeId;
        })   
    },
    fetchTable(){
        let _this = this;
        let params = { 
          stockCode:this.paramsData.stockCode,  
          enterpriseCode:this.paramsData.enterpriseCode,  
        //   announcementType: this.searchData1.type,
          offset:this.offset,
          limit:this.limit
        }
        api.cinformationOne(params).then(res=>{
            let data = res.data.rows;
            // _this.total = Math.ceil(Number(res.data.total)/Number(_this.limit));
            _this.total = res.data.total;
            console.log(res,'data');
            _this.tableData = data;
        })   
    }
  },
  mounted() {
  }
};
</script>
<style scoped lang="less">
@import "../../assets/less/style.less";
.right {
  flex: 1;
  height: auto;
  margin-right: 23px;
  display: flex;
  flex-direction: column;
  .rightTop {
    width: auto;
    height: auto;
    margin-right: 20px;
    background: #ffffff;
    border-radius: 2px;
    display: flex;
    flex-direction: column;
    padding: 0 20px 10px;
    .title {
      height: 50px;
      line-height: 50px;
      border-bottom: 1px solid #dfdfdf;
      display: flex;
      justify-content: space-between;
      align-items: center;
      span {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333;
      }
      .button {
        width: 88px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background: #3583ed;
        border-radius: 2px;
        color: #fefefe;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
      }
    }
    .con {
      width: auto;
      flex: 1;
      font-size: 14px;
      font-family: Microsoft YaHei;
      color: #404040;
      display: flex;
      flex-direction: column;
      p {
        padding-top: 10px;
      }
    }
  }
  .rightCenter {
    width: auto;
    height: 61px;
    line-height: 61px;
    margin-right: 20px;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .centerTit {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
    }
    .centerCon {
      width: auto;
      height: 61px;
      line-height: 61px;
      display: flex;
      .no {
        span {
          display: inline-block;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333;
        }
      }
      .excel {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #3583ed;
        img {
          display: inline-block;
          width: 18px;
          height: 18px;
          transform: translate(0, 20%);
        }
      }
    }
  }
  .rightBottom {
    width: auto;
    height: auto;
    margin-right: 20px;
    margin-bottom: 40px;
    padding: 20px 20px 50px 20px;
    background: #fff;
    .tabulation {
      width: 100%;
      height: auto;
      // background: lightblue;
    }
  }
}
.mailTable, .mailTable tr, .mailTable tr td{ border:1px solid #DFDFDF; }
.mailTable{ font-size: 14px; color: #4B4B4B; width:100%;font-family:Microsoft YaHei;}
.mailTable tr td{ border:1px solid #DFDFDF; width: 80%; height: 35px; line-height: 35px; box-sizing: border-box; padding: 0 10px; }
.mailTable .column { background-color: #F7F7F7; color: #333333; font-size:14px;font-weight:bold;width:20%;}
</style>


// WEBPACK FOOTER //
// src/view/notice/cinformation.vue